import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { isEqual } from "lodash";

import StatsTable from "components/stats-table";
import BaseCard, { cardLabel, BaseCardProps } from "./BaseCard";
import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";


interface IProps extends BaseCardProps {
  data: any;
  baseUrl: string;
  config: SiteConfig_siteConfig_dashboardConf_components;
}

const PvCard: FunctionComponent<IProps> = memo(function Pv({ data, baseUrl, config, ...rest }) {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <BaseCard {...rest}
      title={intl.formatMessage({
        id: "dashboard__pv____title",
        defaultMessage: `{count, plural,
          one {Photovoltaics}
          other {Photovoltaics}
        } {label}`,
      }, {
        ...cardLabel(config),
      })}
      control={data?.pv_control}
      image={"/images/svg/fotovoltaicka-elektrarna.svg"}
      onClick={() => {
        navigate(`${baseUrl}/pv${config.id ? `/${config.id}` : ''}`);
      }}
    >
        <StatsTable
          inline
          rows={[
            {
              label: intl.formatMessage({
                id: "dashboard__pv__volt",
                defaultMessage: "Voltage",
              }),
              unit: "V",
              decimals: 2,
              value: data?.voltage,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__pv__amp",
                defaultMessage: "Current",
              }),
              unit: "A",
              decimals: 2,
              value: data?.current,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__pv__kw",
                defaultMessage: "Active power",
              }),
              unit: "kW",
              decimals: 1,
              value: data?.active_power,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__pv__throttled_to",
                defaultMessage: "Throttled to",
              }),
              unit: "%",
              decimals: 1,
              value: data?.throttled_to,
            },
          ]}
        />
    </BaseCard>
  );
}, isEqual);

export default PvCard;
